import {useEffect, useRef} from 'react';
import {eventPrepIdentity} from './eventPrepFocusPoints';
import {mergeLiveFocusPointDraft, subscribeLiveEventFocusPoints} from './liveEventFocusPoints';

const identity = points => points;

// Keep the open web setup draft live without replacing edits made locally.
export default function useLiveSetupFocusPoints({teamId, mapId, matchId, eventId, event,
  selectionKey, disabled = false, setFocusPoints, setLoading, normalize = identity, onError}) {
  const callbacks = useRef(null);
  callbacks.current = {setFocusPoints, setLoading, normalize, onError};
  const baseline = useRef({key: null, points: null});
  const key = JSON.stringify([teamId, mapId, eventId || selectionKey]);
  useEffect(() => {
    const handlers = callbacks.current;
    if (disabled) {handlers.setLoading(false); return undefined;}
    if (baseline.current.key !== key) {
      baseline.current = {key, points: null};
      handlers.setFocusPoints([]);
    }
    if (!teamId || !mapId || (!eventId && !matchId) || eventPrepIdentity(event || {}, eventId).scope === 'personal') {
      handlers.setLoading(false);
      return undefined;
    }
    handlers.setLoading(true);
    let closed = false;
    const stop = subscribeLiveEventFocusPoints({teamId, mapId, matchId, eventId, event: event || {},
      onChange: points => {
        if (closed) return;
        const next = callbacks.current.normalize(points);
        const previous = baseline.current.points;
        baseline.current.points = next;
        callbacks.current.setFocusPoints(current => mergeLiveFocusPointDraft(current, previous, next));
        callbacks.current.setLoading(false);
      },
      onError: error => {
        if (closed) return;
        callbacks.current.setLoading(false);
        callbacks.current.onError?.(error);
      },
    });
    return () => {closed = true; stop();};
  }, [teamId, mapId, matchId, eventId, event, key, disabled]);
}
